// node_modules
import "bootstrap";
import objectFitImages from "object-fit-images";
import LazyLoad from "vanilla-lazyload";
import flatpickr from "flatpickr";

//global parts
import "./geoLocation";
import "./videos";

//components
import "../components/swiper";
//import locationSeatsNeeded from "../components/location-seats-needed";
import waitForGlobal from "../components/wait-for-global";
import handleForms from "../components/handle-form";
import changeSelectColorForm from "../components/change-select-color-form";
import handleModals from "../components/handle-modals";
import handleWebsiteBanners from "../components/handle-website-banners";
import handleCollapsedMenu from "../components/handle-collapsed-menu";
import adjustCollapseView from "../components/adjust-collapse-view";
import handleMenu from "../components/handle-menu";
import handleExperiments from "../components/handle-experiments";
import toggleShowClassMobileFormOverlay from "../components/toggle-show-class-mobile-form-overlay";
import scrollToPoint from "../components/scroll-to-point";
import addTitleReviewsIframe from "../components/add-title-reviews-iframe";
import handleBreadcrumbsMobile from "../components/handle-breadcrumbs-mobile";
import locationSeatsNeeded from "../components/location-seats-needed";
import globalAccess from "../components/global-access";

import ThankYou from "../components/form/thank-you";
import { calendly_meeting_scheduled } from "../components/calendly/util";

$(function () {
  handleBreadcrumbsMobile();
  waitForGlobal("MktoForms2", handleForms);
  changeSelectColorForm();
  handleModals();
  handleWebsiteBanners();
  handleCollapsedMenu();
  adjustCollapseView();
  handleMenu();
  waitForGlobal("gaData", handleExperiments);
  toggleShowClassMobileFormOverlay();
  scrollToPoint();
  addTitleReviewsIframe();
  locationSeatsNeeded.init();
  globalAccess.init();
  //lazy loading
  new LazyLoad({
    elements_selector: ".lazy",
  });

  flatpickr(".f_date_and_time", {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    minDate: "today",
    disableMobile: "true",
    static: true,
  });

  const dateInput = document.querySelectorAll(".f_date_and_time");

  dateInput &&
    dateInput.forEach((elem) => {
      elem.addEventListener("click", () => {
        elem.value ? false : (elem.value = " ");
      });
    });

  //IE11 support
  objectFitImages($(".stretch-image"));

  $(window).on("scroll", function () {
    $("body").toggleClass("down", $(window).scrollTop() > 40);
  });

  setTimeout(() => {
    $("[name='viewport']").attr(
      "content",
      "width=device-width, initial-scale=1"
    );

    $("[aria-hidden='true'] *").attr("tabindex", "-1");
  }, 100);

  //Tooltips
  $('[data-toggle="tooltip"]').tooltip();
});
// SET TOP POSITION FOR STICKY

const setStickyWithNav = () => {
  const navHeight = $("#wpadminbar").length
    ? $(".sticky-nav-with-banner").innerHeight() +
      $("#wpadminbar").innerHeight()
    : $(".sticky-nav-with-banner").innerHeight();
  document.documentElement.style.setProperty(
    "--sticky-with-nav",
    `${navHeight}px`
  );
};

$(window).on("resize load", function () {
  setStickyWithNav();
});

$(".close-banner").on("click", function () {
  setTimeout(() => {
    setStickyWithNav();
  }, 150);
});

setStickyWithNav();

setTimeout(() => {
  setStickyWithNav();
}, 1000);

$(document).on("click", ".calendly-close-overlay", function () {
  if (!$(".js-calendly-send").length) {
    $("body").removeClass("modal-open");
    $("body").css("padding-right", 0);
  } else {
    //$("body").removeClass("js-hide-modal");
  }
});

if ($(".js-scroll-to-wrapper").length > 0) {
  scrollToPoint(".js-scroll-to-wrapper a");
}

// Dynamic landing page form height should be set as var
const formInnerHeight = $("#js-sidebar-form").length
  ? $("#js-sidebar-form").innerHeight()
  : 640;
let r = document.querySelector(":root");
r.style.setProperty("--dl-form-height", formInnerHeight + "px");

/* eslint-disable */
window.translate = js_translate;
/* eslint-enable */

function isCalendlyEvent(e) {
  return (
    e.origin === "https://calendly.com" &&
    e.data.event &&
    e.data.event.indexOf("calendly.") === 0
  );
}

//EVENTS
window.addEventListener("message", (e) => {
  if (isCalendlyEvent(e)) {
    if (e.data.event === "calendly.event_scheduled") {
      calendly_meeting_scheduled();
      let form = document.querySelector(".js-calendly")
        ? document
            .querySelector(".js-calendly")
            .parentElement.querySelector("form")
        : false;

      if (form) {
        ThankYou.init();
      } else {
        form = document.querySelector("form.calendly");

        if (form) {
          ThankYou.init();
        }
      }
    }
  }
});
